import { Styles } from '@monkvision/types';

export const styles: Styles = {
  vehicleCoveredSvg: {
    width: '100%',
    height: 'auto',
  },
};
